import React from 'react';

interface Props {
  name: string;
  className?: string;
}

// References a <symbol> defined once in IconSprite.tsx (mounted in App.tsx).
const Icon: React.FC<Props> = ({ name, className = 'icon' }) => (
  <svg className={className} aria-hidden="true">
    <use href={`#i-${name}`} />
  </svg>
);

export default Icon;
